<template>
    <select v-model="val" class="form-control form-select" :class="selectClasses" :disabled="disabled">
        <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
    </select>
</template>

<script setup lang="ts">
import { computed } from "vue";

defineOptions({ name: "UiSelect" });

export interface UiSelectOption {
    value: string;
    label: string;
}

const val = defineModel<string>("val");

const {
    options,
    compact = false,
    disabled = false,
    autoFocus = false,
} = defineProps<{
    options: UiSelectOption[];
    compact?: boolean;
    disabled?: boolean;
    autoFocus?: boolean;
}>();

const selectClasses = computed(() => {
    return {
        "form-select-compact": compact,
        "form-control-full-width": !compact,
        "auto-focus": autoFocus,
    };
});
</script>
